const iconConfig = [{
	name: 'iconNext',
	inputType: 'icon',
	label: 'Choose next icon',
	default: false
}, {
	name: 'iconNextSize',
	inputType: 'text',
	label: 'Set size on next icon',
	default: '2em'
}, {
	name: 'iconNextColor',
	inputType: 'color',
	label: 'Set color on next icon',
	default: '#000'
}, {
	name: 'iconPrev',
	inputType: 'icon',
	label: 'Choose previous icon',
	default: false
}, {
	name: 'iconPrevSize',
	inputType: 'text',
	label: 'Set size on previous icon',
	default: '2em'
}, {
	name: 'iconPrevColor',
	inputType: 'color',
	label: 'Set color on previous icon',
	default: '#000'
}];

const imageConfig = [{
	name: 'imageNext',
	inputType: 'media',
	label: 'Choose next image',
	default: ''
}, {
	name: 'imagePrev',
	inputType: 'media',
	label: 'Choose previous image',
	default: ''
}];

const conditionallyAddConfig = (node, conditionStr, configArray) => (node && node.props.type === conditionStr) ? configArray : [];

export default node => ({
	type: 'ARTICLES_SLIDER',
	name: 'Articles slider',
	allowedSections: ['main', 'footer', 'header'],
	disallowedChildren: ['*'],
	category: 'Articles',
	props: [{
		label: 'Source',
		name: 'source',
		inputType: 'select',
		values: [{
			label: 'Recent views',
			value: 'recent'
		}, {
			label: 'Selection',
			value: 'selection'
		}, {
			label: 'Category',
			value: 'category'
		}],
		default: 'recent'
	}, node && node.props.source === 'category' && {
		name: 'categoryId',
		inputType: 'link',
		label: 'Source category',
		default: '',
		requestKey: 'categoryId'
	}, node && node.props.source === 'selection' && {
		name: 'articleNumbers',
		inputType: 'text',
		label: 'Article numbers (eg. 1234, 5678, 91011)',
		default: ''
	}, {
		name: 'size',
		inputType: 'slider',
		label: 'Number of articles to load',
		default: 10,
		min: 1,
		max: 20
	}, {
		name: 'image',
		inputType: 'select',
		label: 'Image',
		default: '1010',
		values: [{
			label: 'Front',
			value: '1010'
		}, {
			label: 'Back',
			value: '1011'
		}, {
			label: 'List',
			value: '1020'
		}]
	}, {
		name: 'imageOnHover',
		inputType: 'select',
		label: 'Image on hover',
		default: '-1',
		values: [{
			label: 'Front',
			value: '1010'
		}, {
			label: 'Back',
			value: '1011'
		}, {
			label: 'List',
			value: '1020'
		}, {
			label: 'None',
			value: '-1'
		}]
	}, {
		name: 'showShortDescription',
		inputType: 'checkbox',
		label: 'Show short description',
		default: false
	}, {
		name: 'showMoreInfo',
		inputType: 'checkbox',
		label: 'Show read more button',
		default: false
	}, node && node.props.showMoreInfo && {
		name: 'showMoreInfoText',
		inputType: 'text',
		label: 'Read more button text'
	}, {
		name: 'pricePrefix',
		inputType: 'text',
		label: 'Price prefix'
	}, {
		name: 'priceSuffix',
		inputType: 'text',
		label: 'Price suffix'
	}].filter(Boolean),
	hiddenProps: [{
		label: 'Slider settings',
		props: [{
			name: 'play',
			inputType: 'checkbox',
			label: 'Autoplay',
			default: false
		}, {
			name: 'loop',
			inputType: 'checkbox',
			label: 'Loop',
			default: false
		}, {
			name: 'speed',
			inputType: 'text',
			label: 'Animation speed',
			default: '300'
		}, {
			name: 'duration',
			inputType: 'text',
			label: 'Animation duration',
			default: '3000'
		}, {
			name: 'effect',
			inputType: 'select',
			label: 'Effect',
			default: 'slide',
			values: [{
				label: 'Slide',
				value: 'slide'
			}, {
				label: 'Fade',
				value: 'fade'
			}, {
				label: 'cube',
				value: 'cube'
			}, {
				label: 'Coverflow (Needs fixed height)',
				value: 'coverflow'
			}, {
				label: 'Flip',
				value: 'flip'
			}]
		}, {
			name: 'timing',
			inputType: 'select',
			label: 'Transition',
			default: 'ease',
			values: [{
				label: 'Linear',
				value: 'linear'
			}, {
				label: 'Ease',
				value: 'ease'
			}, {
				label: 'Ease-in',
				value: 'ease-in'
			}, {
				label: 'Ease-out',
				value: 'ease-out'
			}, {
				label: 'Ease-in-out',
				value: 'ease-in-out'
			}]
		}]
	}, {
		label: 'Navigation',
		props: [{
			name: 'arrows',
			inputType: 'checkbox',
			label: 'Show Arrows',
			default: true
		}, {
			name: 'type',
			inputType: 'select',
			label: 'Choose arrow type',
			default: 'none',
			values: [{
				label: 'Native',
				value: 'none'
			}, {
				label: 'Icon',
				value: 'icon'
			}, {
				label: 'Image',
				value: 'image'
			}]
		},
			...conditionallyAddConfig(node, 'icon', iconConfig),
			...conditionallyAddConfig(node, 'image', imageConfig),
		{
			name: 'pagination',
			inputType: 'checkbox',
			label: 'Show Pagination',
			default: true
		}, {
			name: 'paginationType',
			inputType: 'select',
			label: 'Choose pagination type',
			default: 'bullets',
			values: [{
				label: 'Bullets',
				value: 'bullets'
			}, {
				label: 'Fraction',
				value: 'fraction'
			}]
		}]
	}, {
		label: 'Slide options mobile',
		props: [{
			name: 'slidesPerViewMobile',
			inputType: 'select',
			label: 'Slides per view',
			default: '1',
			values: ['1', '2', '3', '4', '5', '6', '7', '8']
		}, {
			name: 'slidesPerColumnMobile',
			inputType: 'select',
			label: 'Slides per column',
			default: '1',
			values: ['1', '2', '3', '4']
		}, {
			name: 'spaceBetweenMobile',
			inputType: 'select',
			label: 'Space between',
			default: '0',
			values: ['0', '10', '20', '30', '40']
		}, {
			name: 'centerSlidesMobile',
			inputType: 'checkbox',
			label: 'Center slides',
			default: false
		}]
	}, {
		'label': 'Slide options tablet',
		'props': [{
			'name': 'slidesPerViewTablet',
			'inputType': 'select',
			'label': 'Slides per view',
			'default': '3',
			'values': ['1', '2', '3', '4', '5', '6', '7', '8']
		}, {
			'name': 'slidesPerColumnTablet',
			'inputType': 'select',
			'label': 'Slides per column',
			'default': '1',
			'values': ['1', '2', '3', '4']
		}, {
			'name': 'spaceBetweenTablet',
			'inputType': 'select',
			'label': 'Space between',
			'default': '0',
			'values': ['0', '10', '20', '30', '40']
		}, {
			'name': 'centerSlidesTablet',
			'inputType': 'checkbox',
			'label': 'Center slides',
			'default': false
		}]
	}, {
		'label': 'Slide options desktop',
		'props': [{
			'name': 'slidesPerViewDesktop',
			'inputType': 'select',
			'label': 'Slides per view',
			'default': '5',
			'values': ['1', '2', '3', '4', '5', '6', '7', '8']
		}, {
			'name': 'slidesPerColumnDesktop',
			'inputType': 'select',
			'label': 'Slides per column',
			'default': '1',
			'values': ['1', '2', '3', '4']
		}, {
			'name': 'spaceBetweenDesktop',
			'inputType': 'select',
			'label': 'Space between',
			'default': '0',
			'values': ['0', '10', '20', '30', '40']
		}, {
			'name': 'centerSlidesDesktop',
			'inputType': 'checkbox',
			'label': 'Center slides',
			'default': false
		}]
	}, {
		label: 'Badge settings',
		props: [{
			name: 'showSaleOrNew',
			inputType: 'checkbox',
			label: 'Show sale or new icon',
			default: false
		}, {
			name: 'showCampaigns',
			inputType: 'checkbox',
			label: 'Show campaign icon',
			default: true
		}, {
			name: 'campaignPopup',
			inputType: 'checkbox',
			label: 'Popup on campaign click',
			default: false
		}, {
			name: 'campaignHeader',
			inputType: 'text',
			label: 'Campaign popup header',
			default: ''
		}]
	}]
});
